import React from 'react';
import { Project } from '../types';
import ProjectCard from './ProjectCard';

interface Props {
  projects: Project[];
  /** `null` while the announcement is still loading. */
  selectedId: number | null;
  onSelect: (id: number) => void;
}

const ProjectGrid: React.FC<Props> = ({ projects, selectedId, onSelect }) => (
  <section className="sa-projects">
    <div className="sa-projects__header">
      <h2 className="sa-projects__title">Layihə seçimi</h2>
    </div>

    <div className="sa-projects__grid">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          isActive={project.id === selectedId}
          onSelect={onSelect}
        />
      ))}
    </div>
  </section>
);

export default ProjectGrid;